var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{on:{"click":function($event){return _vm.$emit('categoryDidSelected', _vm.category)}}},[_c('v-card-subtitle',{staticClass:"line-break pa-2 text-center"},[_vm._v(" "+_vm._s(_vm.category.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }